<script lang="ts">
  let props = $props()
  let { score } = props
</script>

{#if score.total < 25}
  <h2
    class="mt-2 text-xl font-semibold tracking-tight text-gray-950 sm:text-3xl"
  >
    A Note Before You Begin
  </h2>
  <p class="mt-6 text-base sm:text-lg/8 text-gray-700 font-semibold">
    You just answered 15 scenario-based questions that cut through the noise and
    expose how your team actually operates under pressure.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700">
    This wasn’t theory. And this score isn’t sugar-coated.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700 font-bold">
    Let’s be clear:
  </p>
  <p class="mt-2 text-base sm:text-lg/8 text-gray-700 ml-4 italic">
    You’re not leading a ready team - you’re surviving through personal effort,
    patchwork solutions, and constant firefighting.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-red-900 font-bold">
    Your Readiness Score is dangerously low.
  </p>
{:else if score.total >= 25 && score.total < 50}
  <h2
    class="mt-2 text-xl font-semibold tracking-tight text-gray-950 sm:text-3xl"
  >
    A Note Before You Begin
  </h2>
  <p class="mt-6 text-base sm:text-lg/8 text-gray-700 font-semibold">
    You just answered 15 situational questions.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700">
    Not hypotheticals. Not theory. These were real leadership moments - the kind
    that reveal what your team actually experiences when you're not in the room.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700 italic font-semibold">
    And based on your responses, you’re carrying more weight than you realize.
  </p>
{:else if score.total >= 50 && score.total < 80}
  <h2
    class="mt-2 text-xl font-semibold tracking-tight text-gray-950 sm:text-3xl"
  >
    A Note Before You Begin
  </h2>
  <p class="mt-6 text-base sm:text-lg/8 text-gray-700 font-semibold">
    You just answered 15 hard questions.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700">
    Not theoretical ones - <span class="font-semibold"
      >real, situational ones.</span
    > The kind that reveal what your team actually experiences when you’re not in
    the room.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700 italic">
    This isn’t about what you hope is true. This is about how your organization
    really operates under pressure.
  </p>
{:else if score.total >= 80 && score.total < 99}
  <h2
    class="mt-2 text-xl font-semibold tracking-tight text-gray-950 sm:text-3xl"
  >
    A Note Before You Begin
  </h2>
  <p class="mt-6 text-base sm:text-lg/8 text-gray-700">
    You just answered 15 hard, situational questions - the kind that reveal how
    your team really operates under pressure.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700 font-bold">
    Not in theory. Not on paper. But in the moments that matter most.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700 italic">
    This score isn’t a pat on the back. It’s a mirror.
  </p>
{:else if score.total == 100}
  <h2
    class="mt-2 text-xl font-semibold tracking-tight text-gray-950 sm:text-3xl"
  >
    A Note Before You Begin
  </h2>
  <p class="mt-6 text-base sm:text-lg/8 text-gray-700 font-semibold">
    You just answered 15 tough, real-world leadership scenarios - not
    hypotheticals. This score doesn’t measure optimism. It measures operational
    reality.
  </p>
  <p class="mt-4 text-base sm:text-xl/8 text-blue-900 font-bold">
    And you scored 100%.
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700">
    That means you’re doing what few leaders ever manage: <span
      class="font-semibold"
      >Building a team that can move fast, lead well, and deliver under pressure
      - with or without you in the room.</span
    >
  </p>
  <p class="mt-4 text-base sm:text-lg/8 text-gray-700 italic">
    But before you celebrate… let’s talk about what 100% really means.
  </p>
{/if}
